import { render, staticRenderFns } from "./AddSmallClass.vue?vue&type=template&id=3cb1961e&scoped=true"
import script from "./AddSmallClass.vue?vue&type=script&lang=js"
export * from "./AddSmallClass.vue?vue&type=script&lang=js"
import style0 from "./AddSmallClass.vue?vue&type=style&index=0&id=3cb1961e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb1961e",
  null
  
)

export default component.exports